<template>
  <div class="min-h-full bg-gray-800 notification-list">
    <!-- Loading state -->
    <div v-if="loading && notifications.length === 0" class="py-12">
      <div class="flex flex-col gap-3 justify-center items-center">
        <div
          class="rounded-full border-gray-700 animate-spin size-8 border-3 border-t-blue-500" />
        <p class="text-sm font-medium text-gray-300">
          Loading notifications...
        </p>
      </div>
    </div>

    <!-- Empty state -->
    <div
      v-else-if="notifications.length === 0"
      class="flex flex-col gap-4 justify-center items-center py-16">
      <div
        class="size-20 rounded-full bg-gray-800/80 border border-gray-700/50 flex items-center justify-center shadow-lg">
        <fa-icon :icon="['far', 'bell']" class="text-3xl text-gray-400" />
      </div>
      <div class="text-center">
        <p class="text-base font-semibold text-gray-200">
          No notifications yet
        </p>
        <p class="mt-2 text-sm text-gray-400">
          You'll see updates from your clubs here
        </p>
      </div>
    </div>

    <!-- Notification items -->
    <div v-else class="p-2 space-y-2">
      <NotificationItem
        v-for="notification in notifications"
        :key="notification.id"
        :notification="notification"
        :show-unread-indicator="showUnreadIndicator"
        @click="handleNotificationClick" />

      <!-- Load more button -->
      <div v-if="hasMore" class="px-2 pt-2 pb-4">
        <button
          :disabled="loadingMore"
          class="w-full py-3 px-4 text-sm font-medium text-gray-200 bg-gray-800/80 hover:bg-gray-700 border border-gray-700/50 hover:border-gray-600 rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed shadow-sm"
          @click="$emit('load-more')">
          <span v-if="loadingMore">Loading...</span>
          <span v-else>Load more</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import NotificationItem from './NotificationItem.vue'

defineProps({
  notifications: {
    type: Array,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  loadingMore: {
    type: Boolean,
    default: false
  },
  hasMore: {
    type: Boolean,
    default: false
  },
  showUnreadIndicator: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['load-more', 'refresh', 'notification-click'])

const handleNotificationClick = (notification) => {
  emit('notification-click', notification)
}
</script>
